import { FormControl } from "@mui/material";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import Switch from "react-switch";

const SwitchController = ({
  control,
  name,
  label,
  errors,
  required,
  extraRules,
  disabled,
  styles,
}) => {
  const formContext = useFormContext();
  const formErrors = errors || formContext?.formState?.errors || {};
  return (
    <FormControl
      style={{ minWidth: 400, marginTop: 20, marginBottom: 20, ...styles }}
    >
      <div
        style={{
          display: "flex",
        }}
      >
        <p
          style={{
            marginRight: 10,
          }}
        >
          {label}
        </p>
        <Controller
          control={control}
          name={name}
          rules={{
            required: {
              value: !!required,
              message: `${name} is required.`,
            },
            ...extraRules,
          }}
          render={({ field: { onChange, value } }) => (
            <Switch
              disabled={disabled}
              onChange={(checked) => {
                onChange(checked);
              }}
              value={value}
              checked={value}
            />
          )}
        />
      </div>

      <p style={{ color: "red" }}>{formErrors[name]?.message}</p>
    </FormControl>
  );
};

export default SwitchController;
